import { breakpoints } from "../constants/breakpoints"

export const mediaQuery = breakpoints.map(
  breakpoint => `@media (min-width: ${breakpoint}px)`
)
